import {PolicyLapseA as PolicyLapseALetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

type PolicyLapseAProps = {
  policyLapseALetter: PolicyLapseALetter;
};

const PolicyLapseA = (props: PolicyLapseAProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.policyLapseALetter.date)} />
      <CardField name="Coverage Case Date" value={toFormattedDateAsUTC(props.policyLapseALetter.coverageCeaseDate)} />
      <CardField name="Coverage Type" value={props.policyLapseALetter.coverageType} />
      <CardField name="Agent Number" value={props.policyLapseALetter.agentNumber} />
      <CardField name="Insured Name" value={props.policyLapseALetter.insuredName} />
      <CardField name="Owner Name" value={props.policyLapseALetter.ownerName} />
      <CardField name="Owner Address" value={props.policyLapseALetter.ownerAddress!.fullAddress} />
      <CardField name="Policy Number" value={props.policyLapseALetter.policyNumber} />
    </>
  );
};

export default PolicyLapseA;
